// extracted by mini-css-extract-plugin
module.exports = {"paymentOptions":"payment-options-module--paymentOptions--35Hyc"};